"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HotelTrustYouGoodToKnowItem = _interopRequireDefault(require("../HotelTrustYouGoodToKnowItem"));

var _excluded = ["data"];
var setiment = _HotelTrustYouGoodToKnowItem["default"].SENTIMENT;

var HotelTrustYouGoodToKnowList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTrustYouGoodToKnowList, props, data.map(function (_ref2) {
    var text = _ref2.text,
        category_name = _ref2.category_name,
        sentiment = _ref2.sentiment;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: category_name
    }, /*#__PURE__*/_react["default"].createElement(StyledItem, {
      sentiment: sentiment
    }, text));
  }));
});

HotelTrustYouGoodToKnowList.propTypes = {
  className: _propTypes["default"].string,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    count: _propTypes["default"].number.isRequired,
    sentiment: _propTypes["default"].oneOf(Object.keys(setiment).map(function (item) {
      return setiment[item];
    })),
    category_id: _propTypes["default"].string.isRequired,
    category_name: _propTypes["default"].string.isRequired,
    text: _propTypes["default"].string.isRequired,
    short_text: _propTypes["default"].string.isRequired
  }).isRequired).isRequired
};
HotelTrustYouGoodToKnowList.defaultProps = {
  className: ''
};

var StyledHotelTrustYouGoodToKnowList = _styledComponents["default"].ul.withConfig({
  displayName: "HotelTrustYouGoodToKnowList__StyledHotelTrustYouGoodToKnowList",
  componentId: "sc-4bqw86-0"
})([""]);

var StyledItem = (0, _styledComponents["default"])(_HotelTrustYouGoodToKnowItem["default"]).withConfig({
  displayName: "HotelTrustYouGoodToKnowList__StyledItem",
  componentId: "sc-4bqw86-1"
})(["margin-bottom:10px;font-size:14px;"]);
HotelTrustYouGoodToKnowList.Item = StyledItem;
var _default = HotelTrustYouGoodToKnowList;
exports["default"] = _default;